import { Injectable } from "@angular/core";
import { LogService } from "ng/src/app/logs/log.service";
import { HttpClient } from "@angular/common/http";
import { GeneralParameters, Projections } from "app/shared/model/request-parameter.model";
import { HALResponse } from "ng/src/app/shared/model/app.model";
import { AlertEvent, AlertEventResponse, ReportAlertTrigger } from "ng/src/app/alerts/shared/alert.model";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { PagedEntity } from "app/shared/model/app.model";

@Injectable({
	providedIn: 'root'
})
export class AlertService {
	
	constructor(
		private http: HttpClient
	) { }
	
	getEvents(): Observable<AlertEventResponse<AlertEvent.Projections.Detailed>> {
		const params: GeneralParameters = {
			isMostRecent: true,
			projection: Projections.AlertEvent.detailed,
			'alertInstance.alertObject.log': LogService.selectedLog?.id
		};
		return this.http.get<HALResponse<{ alertEvents: AlertEvent.Projections.Detailed[] }>>('/api/alertEvents', { params: params })
			.pipe(
				map(res => PagedEntity.from(res._embedded.alertEvents, res.page)
			))
	}
	
	fetchTriggers(query: GeneralParameters) {
		return this.http.get<HALResponse<{ reportAlertTriggers: ReportAlertTrigger[] }>>('/api/reportAlertTriggers',{ params: query })
			.pipe(map(res => PagedEntity.from(res._embedded.reportAlertTriggers, res.page)));
	}
	
	deleteReportAlertTrigger(trigger: ReportAlertTrigger) {
		return this.http.delete(trigger._links.self.href);
	}
}